import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { MovementPageRemovePetitionFromMovement } from './removePetitionFromMovement.graphql';
import type {
	MovementPageRemovePetitionFromMovementMutation,
	MovementPageRemovePetitionFromMovementMutationVariables,
} from './removePetitionFromMovement.graphql';

export async function removePetitionFromMovement(
	petitionId: string,
	movementId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data } = await fetch<
		MovementPageRemovePetitionFromMovementMutation,
		MovementPageRemovePetitionFromMovementMutationVariables
	>({
		query: MovementPageRemovePetitionFromMovement,
		variables: { input: { petitionId, movementId } },
		rejectOnError: true,
	});

	if (data.removePetitionFromMovement.__typename === 'MovementMutationResponseError') {
		throw new Error(`Error removing petition from the movement: ${data.removePetitionFromMovement.error}`);
	}
	return data.removePetitionFromMovement.success;
}
